export const shouldApproveEtanolChecklist = data => {
  return (
    data.volumeordem !== '' &&
    data.volumeordem !== null &&
    data.tipocarreta !== '' &&
    data.lacres !== '' &&
    data.printer !== ''
  );
};

export const shouldApproveVhpChecklist = data => {
  return (
    data.volumeordem !== '' &&
    data.volumeordem !== null &&
    data.tipocarreta !== '' &&
    data.cnh &&
    data.epis &&
    data.roupasApropriadas &&
    // data.acompanhantes &&
    data.alertaVazamentos &&
    data.alertaAlimentacao &&
    data.alertaSomAlto &&
    // data.paraChoques &&
    // data.placasDanificadas &&
    // data.faroisDanificados &&
    // data.lanternasSetasDanificadas &&
    data.extintorIncendio &&
    // data.vazamentoCombustivel &&
    data.fitasRefletivas &&
    data.pneusBomEstado &&
    // data.galoes &&
    // data.buracos &&
    // data.odorEstranho &&
    // data.presencaPragas &&
    // data.residuoCarga &&
    // data.umidade &&
    // data.limpo &&
    // data.lonaComResiduos &&
    // data.lonaDanificada &&
    data.lonaLimpa &&
    data.lonaSeca &&
    // data.lonaOdorEstranho &&
    // data.lonaPresencaPragas &&
    // data.lonaResiduoCarga &&
    data.lacres !== ''
  );
};
